import VueRouter from "vue-router";

import AuthService from "./services/auth";
import AppFrame from "./AppFrame";

import Login from "./views/Login";
import Home from "./views/Home";
import Levels from "./views/Levels";
import Timeline from "./views/Timeline";
import Players from "./views/Players";
import GameStats from "./views/GameStats";
import Conversions from "./views/Conversions";
import ABTests from "./views/ABTests";
import Countries from "./views/Countries";

const router = new VueRouter({
    mode: "hash",
    routes: [
        {
            name: "login",
            path: "/login",
            component: Login,
        },
        {
            component: AppFrame,
            path: "/",
            children: [
                {
                    name: "home",
                    path: "/",
                    component: Home,
                },
                {
                    name: "level-stats",
                    path: "/level-stats",
                    component: Levels,
                },
                {
                    name: "player-stats",
                    path: "/player-stats",
                    component: Players,
                },
                {
                    name: "timeline",
                    path: "/timeline",
                    component: Timeline,
                },
                {
                    name: "game-stats",
                    path: "/game-stats",
                    component: GameStats,
                },
                {
                    name: "conversions",
                    path: "/conversions",
                    component: Conversions,
                },
                {
                    name: "ab-tests",
                    path: "/ab-tests",
                    component: ABTests,
                },
                {
                    name: "countries",
                    path: "/countries",
                    component: Countries,
                },
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (AuthService.loggedIn) {
        if (to.name === "login") {
            console.log("redir to home");
            next({ name: "home" });
        } else {
            console.log("no redir");
            next();
        }
    } else {
        if (to.name !== "login") {
            console.log("redir to login");
            next({ name: "login" });
        } else {
            next();
        }
    }
});

export default router;
